import React from "react";
import moment from "moment-timezone";


export const rejectedFeedColumn = (userinfo) => [
    {
        Header: "Requested ID",
        accessor: "srId",
        className: "text-center align-middle text-nowrap",
    },
    {
        Header: "Customer Status",
        accessor: (d) => {
            return (
                <>
                    {d.apiOnOff == "1" ? <div className="d-flex align-items-center justify-content-center"><span className="label label-dot label-success"></span><span className="text-success pl-3 font-weight-bolder">Active</span></div>
                        : <div className="d-flex align-items-center justify-content-center"><span className="label label-dot label-danger"></span><span className="text-danger pl-3 font-weight-bolder">InActive</span></div>
                    }
                </>
            );
        },
        className: "text-center align-middle",
    },
    {
        Header: "Country" ,
        accessor: "country",
        className: "text-center align-middle",
        
    },
    {
        Header: "API" ,
        accessor: (d) => {
            return (
                <>
                    <span className="label label-lg label-outline-danger label-pill label-inline bg-danger-o-20 font-weight-bold text-nowrap">Rejected</span>
                </>
            );
        },
        className: "text-center align-middle",
        
    },
    {
        Header: "Rejected Timestamp",
        accessor: (d) => {
            return (
                <>
                    {d.updatedDate?d.updatedDate:""}
                </>
            );
        },
        className: "text-center align-middle",
    }
];
